<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Update Details"
              bc2="Merchant Store"
              bc3="Update"
              path="store"
          ></Breadcrumb>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Udpate Details</h4>
                </div>
                <div class="card-body">
                  <ValidationObserver
                      ref="observer"
                      tag="form"
                      v-slot="{ invalid, validate }"
                  >
                    <form
                        class="form form-horizontal"
                        @submit.prevent="validate().then(sendCall)"
                    >
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">
                              <label for="name-icon">Name</label>
                            </div>
                            <div class="col-sm-9">
                              <ValidationProvider
                                  name="Name"
                                  ref="name"
                                  rules="required"
                                  v-slot="{ errors }"
                              >
                                <div class="input-group">

                                  <input
                                      type="text"
                                      v-model="name"
                                      id="name-icon"
                                      class="form-control"
                                      :class="errors[0] ? 'is-invalid' : ''"
                                      name="name"
                                      placeholder="Name"
                                      v-validate="'required'"
                                  />
                                </div>
                                <small
                                    class="block text-red-600 text-xs absolute bottom-0 left-0"
                                    style="color:#EA5455"
                                >{{ errors[0] }}</small
                                >
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">
                              <label for="mccCode-icon">Mcc Code</label>
                            </div>
                            <div class="col-sm-9">
                              <ValidationProvider
                                  name="MccCode"
                                  ref="mccCode"
                                  rules="required"
                                  v-slot="{ errors }"
                              >
                                <div class="input-group">
                                  <select v-validate="'required'" v-model="mccCode" name="mccCode"  class="form-control">
                                    <option value="">Select Mcc Code</option>
                                    <option v-for="category in categories" :key="category.code" :value="category.code">
                                      {{ category.code }} – {{ category.name }}
                                    </option>
                                  </select>
                                </div>
                                <small
                                    class="block text-red-600 text-xs absolute bottom-0 left-0"
                                    style="color:#EA5455"
                                >{{ errors[0] }}</small
                                >
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>
                        <!-- Auto Settlement -->
                        <div class="col-12">
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">
                              <label for="autoSettlement">Auto Settlement</label>
                            </div>
                            <div class="col-sm-9">
                              <select
                                  v-model="autoSettlement"
                                  id="autoSettlement"
                                  name="autoSettlement"
                                  class="form-control"
                              >
                                <option
                                    v-for="option in autoSettlementOptions"
                                    :key="option.value"
                                    :value="option.value"
                                >
                                  {{ option.label }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <!-- Merchant Descriptor -->
                        <div class="col-12">
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">
                              <label for="merchantDescriptor">Merchant Descriptor <small class="text-muted">(optional)</small></label>
                            </div>
                            <div class="col-sm-9">
                              <input
                                  type="text"
                                  v-model="merchantDescriptor"
                                  id="merchantDescriptor"
                                  name="merchantDescriptor"
                                  class="form-control"
                                  placeholder="Merchant Descriptor"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="card bg-light mt-2 col-sm-9 offset-sm-3 ">
                          <div class="card-header">
                            <h4 class="card-title">Registered business address</h4>
                          </div>

                          <div class="card-body">
                            <div class="row">

                              <!-- Address Line 1 -->
                              <div class="col-12">
                                <ValidationProvider name="Address Line 1"  v-slot="{ errors }">
                                  <div class="form-group">
                                    <label>Address Line 1</label>
                                    <input
                                        type="text"
                                        v-model="addressLine1"
                                        class="form-control"
                                        :class="errors[0] ? 'is-invalid' : ''"
                                    />
                                    <small style="color:#EA5455">{{ errors[0] }}</small>
                                  </div>
                                </ValidationProvider>
                              </div>

                              <!-- Address Line 2 -->
                              <div class="col-12">
                                <ValidationProvider name="Address Line 2"  v-slot="{ errors }">
                                  <div class="form-group">
                                    <label>Address Line 2</label>
                                    <input
                                        type="text"
                                        v-model="addressLine2"
                                        class="form-control"
                                        :class="errors[0] ? 'is-invalid' : ''"
                                    />
                                    <small style="color:#EA5455">{{ errors[0] }}</small>
                                  </div>
                                </ValidationProvider>
                              </div>

                              <!-- Country -->

                              <div class="col-12 col-sm-6">
                                <ValidationProvider name="Country"  v-slot="{ errors }">
                                  <div class="form-group">
                                    <label>Country</label>
                                    <select
                                        v-model="country"
                                        class="form-control"
                                        :class="errors[0] ? 'is-invalid' : ''"
                                    >
                                      <option value="" disabled>Select country</option>
                                      <option
                                          v-for="c in countries"
                                          :key="c.code"
                                          :value="c.code"
                                      >
                                        {{ c.name }}
                                      </option>
                                    </select>
                                    <small style="color:#EA5455">{{ errors[0] }}</small>
                                  </div>
                                </ValidationProvider>
                              </div>


                              <!-- City -->
                              <div class="col-12 col-sm-6">
                                <ValidationProvider name="City"  v-slot="{ errors }">
                                  <div class="form-group">
                                    <label>City or town</label>
                                    <input
                                        type="text"
                                        v-model="city"
                                        class="form-control"
                                        :class="errors[0] ? 'is-invalid' : ''"
                                    />
                                    <small style="color:#EA5455">{{ errors[0] }}</small>
                                  </div>
                                </ValidationProvider>
                              </div>

                              <!-- Postal Code -->
                              <div class="col-12 col-sm-6">
                                <ValidationProvider name="Postal Code"  v-slot="{ errors }">
                                  <div class="form-group">
                                    <label>Post Code</label>
                                    <input
                                        type="text"
                                        v-model="postalCode"
                                        class="form-control"
                                        :class="errors[0] ? 'is-invalid' : ''"
                                    />
                                    <small style="color:#EA5455">{{ errors[0] }}</small>
                                  </div>
                                </ValidationProvider>
                              </div>

                              <!-- Tax Registration Number  -->
                              <div class="col-12 col-sm-6">
                                <ValidationProvider name="Tax Registration Number"  v-slot="{ errors }">
                                  <div class="form-group">
                                    <label>Tax Registration Number</label>
                                    <input
                                        type="text"
                                        v-model="trn"
                                        class="form-control"
                                        :class="errors[0] ? 'is-invalid' : ''"
                                    />
                                    <small style="color:#EA5455">{{ errors[0] }}</small>
                                  </div>
                                </ValidationProvider>
                              </div>

                              <!-- Website -->
                              <div class="col-12 col-sm-6">
                                <ValidationProvider name="Website" rules="url" v-slot="{ errors }">
                                  <div class="form-group">
                                    <label>Website</label>
                                    <input
                                        type="url"
                                        v-model="website"
                                        class="form-control"
                                        :class="errors[0] ? 'is-invalid' : ''"
                                        placeholder="https://example.com"
                                    />
                                    <small style="color:#EA5455">{{ errors[0] }}</small>
                                  </div>
                                </ValidationProvider>
                              </div>

                            </div>
                          </div>
                        </div>
                        <div class="col-12 d-flex mt-5">
                          <button
                              type="submit"
                              class="btn btn-primary mr-1 d-flex"
                              :disabled="loading"
                          >
                            <Loader :loading="loading" :size="size"></Loader>
                            Submit
                          </button>
                          <button
                              type="button"
                              class="btn btn-gradient-secondary"
                              @click="$router.back()"
                          >
                            Back
                          </button>
                        </div>
                      </div>
                    </form>
                  </ValidationObserver>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import { CommandIcon } from "vue-feather-icons";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import mccMixin from "@/mixin/mccMixin";
export default {
  components: {
    CommandIcon,
    ValidationObserver,
    ValidationProvider
  },
  mixins: [mccMixin],
  mounted() {
    this.userId = this.$route.params.userId
    var merchantStoreUpdate = this.$store.getters.getByKey(
        "merchantStoreUpdate2"
    );
    this.storeId =  merchantStoreUpdate.row.id
    this.name =  merchantStoreUpdate.row.name
    this.mccCode =  merchantStoreUpdate.row.mcc_code
    this.index = merchantStoreUpdate.index;
    this.id = merchantStoreUpdate.row.id;
    if(merchantStoreUpdate.row.address){
      this.addressLine1 = merchantStoreUpdate.row.address.addressline1
      this.addressLine2 = merchantStoreUpdate.row.address.addressline2
      this.country = merchantStoreUpdate.row.address.country
      this.city = merchantStoreUpdate.row.address.city
      this.postalCode = merchantStoreUpdate.row.address.postCode
    }
    this.trn = merchantStoreUpdate.row.tax_registration_number
    this.website = merchantStoreUpdate.row.website || ""
    this.merchantDescriptor = merchantStoreUpdate.row.merchant_descriptor || ""
    // Row carries 0 | 1 | 2, the dropdown works with stop | store | channel
    this.autoSettlement = ({ 0: "stop", 1: "store", 2: "channel" })[merchantStoreUpdate.row.auto_settlement] ?? "stop"
  },
  data() {
    return {
      name: "",
      mccCode: "",
      loading: false,
      size: "10px",
      userId:'',
      storeId:'',
      id: "",
      index: "",
      addressLine1: "",
      addressLine2: "",
      country: "",
      city: "",
      postalCode: "",
      trn: "",
      website: "",
      merchantDescriptor: "",
      // Sent as autoSettlement: stop | store | channel (listing returns 0 | 1 | 2)
      autoSettlement: "stop",
      autoSettlementOptions: [
        { value: "stop", label: "Stop" },
        { value: "store", label: "Store|MID" },
        { value: "channel", label: "Channel|TID" },
      ],
      countries: [
        { code: "UAE", name: "United Arab Emirates" },
      ],


    };
  },

  methods: {
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          let data = {
            name: this.name,
            userId: this.userId,
            storeId: this.storeId,
            mccCode: this.mccCode,
            addressline1: this.addressLine1,
            addressline2: this.addressLine2,
            trn: this.trn,
            city: this.city,
            state: this.state,
            postCode: this.postalCode,
            country: this.country,
            website: this.website,
            ...(this.merchantDescriptor ? { merchantDescriptor: this.merchantDescriptor } : {}),
            autoSettlement: this.autoSettlement,

          }
          this.makeRequest("post", "v1/update-store", data).then(
              callResponse => {
                if (!callResponse.error) {
                  let code = callResponse.response.data.code;
                  if (code == 200) {
                    this.loading = false;
                    if (callResponse.response.data.data) {
                      this.$router.back()
                      // let responseData = callResponse.response.data.data;
                      // let storeData = this.$store.getters.getByKey(
                      //     "merchantStoreList2"
                      // );
                      // if (storeData != null) {
                      //   if (typeof storeData.firstPageData != "undefined") {
                      //     if (
                      //         typeof storeData.firstPageData.data[this.index] !=
                      //         "undefined"
                      //     ) {
                      //       if (
                      //           storeData.firstPageData.data[this.index].id ==
                      //           this.id
                      //       ) {
                      //         storeData.firstPageData.data[
                      //             this.index
                      //             ] = responseData;
                      //         delete storeData.otherPageData;
                      //       }
                      //     }
                      //   }
                      //   if (typeof storeData.otherPageData != "undefined") {
                      //     if (
                      //         typeof storeData.otherPageData.data[this.index] !=
                      //         "undefined"
                      //     ) {
                      //       if (
                      //           storeData.otherPageData.data[this.index].id ==
                      //           this.id
                      //       ) {
                      //         storeData.otherPageData.data[
                      //             this.index
                      //             ] = responseData;
                      //       }
                      //     }
                      //   }
                      //   storeData.key = "merchantStoreList2";
                      //   this.$store.dispatch("set", storeData);
                      // }
                      // this.$router.push({
                      //   name: "merchant-stores",
                      //   params: {update: true}
                      // });
                    }
                  } else {
                    this.loading = false;
                  }
                }
              }

          );
        }
      });
    }
  }
};
</script>

